import React from "react";
import { render } from "react-dom";
import {
  transitions,
  positions,
  types,
  Provider as AlertProvider
} from "react-alert";
import AlertTemplate from "react-alert-template-oldschool-dark";
import App from "./App";
import "./index.scss";

// optional cofiguration
const options = {
  position: positions.MIDDLE,
  timeout: 5000,
  offset: "30px",
  transition: transitions.SCALE,
  type: types.ERROR
};

const Root = () => (
  <AlertProvider template={AlertTemplate} {...options}>
    <App />
  </AlertProvider>
);

render(<Root />, document.getElementById("root"));
